/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SelectOptionListResult } from '../models/SelectOptionListResult';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class GridOperatorService {
    /**
     * @returns SelectOptionListResult OK
     * @throws ApiError
     */
    public static getGridOperatorSelectOptions(): CancelablePromise<SelectOptionListResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/GridOperator/select-options',
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
}
